import { render, staticRenderFns } from "./EditCustomerLocation.vue?vue&type=template&id=0d19eb71"
import script from "./EditCustomerLocation.vue?vue&type=script&lang=js"
export * from "./EditCustomerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditCustomerLocation.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d19eb71')) {
      api.createRecord('0d19eb71', component.options)
    } else {
      api.reload('0d19eb71', component.options)
    }
    module.hot.accept("./EditCustomerLocation.vue?vue&type=template&id=0d19eb71", function () {
      api.rerender('0d19eb71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditCustomerLocation.vue"
export default component.exports